import { render, staticRenderFns } from "./DropzoneUpload.vue?vue&type=template&id=93e8353a&scoped=true"
import script from "./DropzoneUpload.vue?vue&type=script&lang=js"
export * from "./DropzoneUpload.vue?vue&type=script&lang=js"
import style0 from "./DropzoneUpload.vue?vue&type=style&index=0&id=93e8353a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e8353a",
  null
  
)

export default component.exports